<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    shape-rendering="geometricPrecision"
    text-rendering="geometricPrecision"
    width="100%"
    height="100%"
>
    <g>
        <path
            d="M14.942545,13.4c0,0,0,0,0,0c.342545,0,.342545,0,.513817-.164384l1.37018-1.808219c0-.164383.171272-.164383,0-.328767l-1.37018-9.369863c0-.164383-.171272-.328767-.513817-.328767-.171273,0-.342545.164384-.342545.493151v11.178082c0,.164383.171272.328767.342545.328767Z"
            transform="translate(.250428-.44956)"
            fill="currentColor"
        />
        <path
            d="M14.942545,13.4c0,0,0,0,0,0c.342545,0,.342545,0,.513817-.164384l1.37018-1.808219c0-.164383.171272-.164383,0-.328767l-1.37018-9.369863c0-.164383-.171272-.328767-.513817-.328767-.171273,0-.342545.164384-.342545.493151v11.178082c0,.164383.171272.328767.342545.328767Z"
            transform="matrix(-.573576-.819152 0.819152-.573576 11.558893 38.336375)"
            fill="currentColor"
        />
        <path
            d="M14.942545,13.4c0,0,0,0,0,0c.342545,0,.342545,0,.513817-.164384l1.37018-1.808219c0-.164383.171272-.164383,0-.328767l-1.37018-9.369863c0-.164383-.171272-.328767-.513817-.328767-.171273,0-.342545.164384-.342545.493151v11.178082c0,.164383.171272.328767.342545.328767Z"
            transform="matrix(-.573576 0.819152-.819152-.573576 38.508274 12.533786)"
            fill="currentColor"
        />
        <path
            d="M17.2,19.5c0,.82875-.67125,1.5-1.5,1.5s-1.5-.67125-1.5-1.5.67125-1.5,1.5-1.5s1.5.67125,1.5,1.5Z"
            transform="translate(.3-3.5)"
            fill="currentColor"
        />
    </g>
</svg>
